import React, { useState } from 'react';
import {
  Box,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Container,
  Paper,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useLanguage } from '../context/LanguageContext';
import Breadcrumb from '../components/Breadcrumb';

// Syllabus content for each pariksha type
const syllabusData = {
  krishna_yajurveda: {
    telugu: {
      title: 'కృష్ణ యజుర్వేదం',
      content: `శ్రీ విద్యారణ్య వైదిక విద్యా విహారమ్ ట్రస్ట్ . భాగ్య నగరం.

వేద శాస్త్ర సంవర్ధినీ సభ 5 వ సంవత్సర

వార్షిక శ్రీకృష్ణ యజుర్వేద పరీక్షలకు అందరికీ స్వాగతం.దక్షిణామ్నాయ శృంగేరి శారదా పీఠాధీశ్వరులు అనంత శ్రీ విభూషితులు శ్రీ శ్రీ భారతీ తీర్థ మహాస్వామి వారు, తత్కరకమల సంజాతులు శ్రీ శ్రీ విధుశేఖర భారతీ మహాస్వామి వారి దివ్య ఆశీస్సులతో గత నాలుగు సంవత్సరాలుగా నిర్విరామంగా వైభవంగా రెండు తెలుగు రాష్ట్రాలలోని శ్రీకృష్ణ యజుర్వేద విద్యార్థులకు మా సంస్థ ద్వారా పరీక్షలు నిర్వహించుచున్నాము. ఈ సంవత్సరము పరీక్షలు వార్షిక మరియూ సంపూర్ణ పట్టా పరీక్షలు మాత్రమే కాకుండా వార్షిక పరీక్షలలో అత్యుత్తమవిద్యార్థి పురస్కారం అలాగే విశేష క్రమ ఘన పరీక్షలు కూడా ఈ సారి నిర్వహింపబడును.

1. వార్షిక పరీక్ష

ఈ సంవత్సరం అధ్యయనం చేసిన (కొత్త గ్రంథం) మరియు ఇదివరకు ఈ సంస్థలో పరీక్ష ఇచ్చిన పాత పన్నాలు (పాతగ్రంథం) పరీక్ష ఇవ్వవలెను. సంవత్సరానికి కొత్త గ్రంథం అత్యధికంగా మూలం 800పనసలు, పదం 1500 పనసలు, క్రమంపూర్తి, జట పూర్తి, ఘనపూర్తి, సత్కారాల వివరం. మూలంలో పన్నానికి 200, పదం 150, క్రమం 120, జటఘనలు 100 రూపాయలు. పాత గ్రంథం పరీక్ష ఇచ్చి ఉత్తీర్ణులైన వారికే ఆయావిభాగాలకు పేర్కొన్న విధంగా సంపూర్ణ సత్కారం జరుగుతుంది. పాత గ్రంథం పరీక్ష ఇవ్వని వారికి అర్థసత్కారం జరుగును

2. క్రమ, ఘన, సామాన్య మరియూ విశేష పరీక్షా నియమాలు & పురస్కారాలు

సామాన్య ఘన పరీక్షా విధానం
దోషాలు: అపస్వరం, అపాక్షరం, కౌళ్లు తప్పుట, అపసంధులు
సత్కారాలు:
• 10 దోషాల లోపు – సాధారణం – ₹15,000
• 8 దోషాల లోపు – ఉత్తమం – ₹20,000
• 6 దోషాల లోపు – అత్యుత్తమం – ₹30,000

సామాన్య క్రమ పరీక్షా విధానం
దోషాలు: అపస్వరం, అపాక్షరం, కౌళ్లు తప్పుట
సత్కారాలు:
• 10 దోషాల లోపు – సాధారణం – ₹8,000
• 8 దోషాల లోపు – ఉత్తమం – ₹12,000
• 6 దోషాల లోపు – అత్యుత్తమం – ₹20,000

వార్షిక పరీక్షలలో సంవత్సరపు అత్యుత్తమ విద్యార్థి పురస్కారం
అర్హత:
• మూలంలో కనీసం 50 పన్నాలు అయ్యి ఉండాలి
• వార్షిక పరీక్షలో హైయెస్ట్ మార్కులు (పర్సంటేజ్) వచ్చిన పదిమంది విద్యార్థులు అర్హులు

విశేష ఘన పరీక్ష
ప్రశ్నలు: జట & ఘన భాగాలలో ఒక వరుస కాకుండా ఎక్కడైనా సరే ఆమూలాగ్రంలో 50 పనసలు, బ్రహ్మణారణ్యకంలో 10 పనసలు (మొత్తం 60 పనసలు)
దోషాలుగా పరిగణించబడేవి: అపస్వరం, అపాక్షరం, బారు, కౌళ్లు, అపసంధులు
సత్కారాలు:
• 4 దోషాల లోపు – రజత పతకం – 1 తులం వెండి (₹50,000)
• 2 దోషాల లోపు – స్వర్ణ పతకం – 2 గ్రా బంగారం + బిరుదు (₹1,00,000)

విశేష క్రమ పరీక్ష
ప్రశ్నలు: మూల పదక్రమ భాగాలలో ఒక వరుస కాకుండా ఎక్కడైనా సరే ఆమూలాగ్రం లో 100 పనసలు
సత్కారాలు:
• 4 దోషాల లోపు – రజత పతకం – 1 తులం వెండి (₹30,000)
• 2 దోషాల లోపు – స్వర్ణ పతకం – 2 గ్రా బంగారం (₹40,000)

సాధారణ పట్టా / అనుత్తీర్ణత నియమాలు
• 4-10 దోషాల మధ్య ఉంటే: విశేష పరీక్షకు వచ్చి 3 దోషాలు దాటితే సామాన్య క్రమాంతం లేదా సామాన్య ఘనాంతం పట్టా ఇవ్వబడును
• 10 దోషాలు దాటితే: అనుత్తీర్ణుడు

వార్షిక పరీక్ష పురస్కార వివరాలు:
కనిష్ఠం 1 పన్నం, గరిష్ఠం 16 పన్నాలకి సత్కారం జరుగును
పదం లో గరిష్ఠం 30 పన్నాలకి సత్కారం జరుగును

పరీక్షకు వచ్చే విద్యార్థులకు సూచనలు:
• సాంప్రదాయ వేష ధారణ కలిగి ఉండాలి
• స్వ శాఖ అధ్యయనం మాత్రమే చేస్తూ ఉండాలి
• నాలుగు రోజుల ఉపనయనం అయ్యి ఉండాలి`
    },
    sanskrit: {
      title: 'कृष्ण यजुर्वेदम्',
      content: `कृष्ण यजुर्वेद परीक्षा प्रणालिका

श्री विद्यारण्य वैदिक विद्या विहारम् ट्रस्ट्

वार्षिक कृष्ण यजुर्वेद परीक्षाणां आयोजनं क्रियते। दक्षिणामन्वयः श्रृङ्गेरी पीठाधीश्वरः श्री श्री भारती तीर्थ महास्वामिः इत्यस्य आशीर्वादेन गतचतुषु वर्षेषु गुणवत्तया रक्षा यजुर्वेद छात्राणां परीक्षा आयोजनं भवति।

वार्षिक परीक्षा विधिः
अस्मिन् वर्षे अधीतग्रन्थः (नवीनग्रन्थः) पूर्ववर्तिनी परीक्षा दत्ताः (प्राचीनग्रन्थः) परीक्षितव्यः। मूलग्रन्थे ८००पनसाः, पदे १५००पनसाः, क्रमपूर्णता, जटपूर्णता, घनपूर्णता परीक्षितव्याः।

सामान्य घन परीक्षा विधिः
दोषाः: अपस्वरम्, अपाक्षरम्, कौळ्यात्मक त्रुटयः, अपसन्धयः
पुरस्कारः:
• १० दोषेभ्यः न्यूनतरे - साधारणम् - ₹१५,०००
• ८ दोषेभ्यः न्यूनतरे - उत्तमम् - ₹२०,०००
• ६ दोषेभ्यः न्यूनतरे - अत्युत्तमम् - ₹३०,०००

विशेष घन परीक्षा विधिः
प्रश्नाः: जटघन भागेषु कश्चिद् वा स्थाने ५० पनसाः, ब्राह्मणारण्यके १० पनसाः
दोषाः: अपस्वरम्, अपाक्षरम्, बारु, कौळ्यात्मक त्रुटयः, अपसन्धयः
पुरस्कारः:
• ४ दोषेभ्यः न्यूनतरे - रजत पदकम् - १ तुलां रजतम् (₹५०,०००)
• २ दोषेभ्यः न्यूनतरे - स्वर्ण पदकम् - २ ग्राम सुवर्णम् (₹१,००,०००)

विशेष क्रम परीक्षा
प्रश्नाः: मूल पदक्रम भागेषु कश्चन वा स्थाने १०० पनसाः
पुरस्कारः:
• ४ दोषेभ्यः न्यूनतरे – रजत पदकम् – १ तुलां रजतम् (₹३०,०००)
• २ दोषेभ्यः न्यूनतरे – स्वर्ण पदकम् – २ ग्राम सुवर्णम् (₹४०,०००)

सामान्य पट्टा / अनुत्तीर्णता नियमाः
• ४-१० दोषेषु सन्ति चेत्: विशेष परीक्षायाम् ३ दोषान् अतिक्रम्य साधारण क्रमान्तं वा साधारण घनान्तं पट्टं दत्तम्।
• १० दोषान् अतिक्रम्य: अनुत्तीर्णः।

वार्षिक परीक्षा पुरस्कार विवरणम्:
कनिष्ठं 1 पनम्, गरिष्ठं 16 पनाम् प्रति सत्कारः भविष्यति।
पदभागे गरिष्ठं 30 पनाम् प्रति सत्कारः भविष्यति।

परीक्षायाः आगच्छन्तः छात्राः प्रति निर्देशाः:
• पारम्परिक वेशधारणं आवश्यकम्।
• स्वशाखायाः अध्ययनमेव करणीयम्।
• चत्वारः दिनानि उपनयनम् कृतम् आवश्यकम्।`
    }
  },
  lakshanam: {
    telugu: {
      title: 'లక్షణం',
      content: `వేద శాస్త్ర సంవర్ధినీ సభా 
వార్షిక లక్షణ పరీక్షా ప్రణాళిక

పాఠ్య భాగం (గ్రంథములు):
1. వర్ణక్రమం
2. ప్రాతిశాఖ్య సూత్రములు
3. వ్యాసశిక్ష సూత్రములు
4. సప్తలక్షణి సూత్రములు
5. ఆత్రేయ శిక్ష
6. కౌండిన్య శిక్ష

ఈ మూలసూత్రముల వరకు మౌఖిక పరీక్ష ఉంటుంది.

మౌఖిక పరీక్ష సత్కారాలు:
1.⁠ ⁠వర్ణక్రమం 5000
2.⁠ ⁠ప్రాతిశాఖ్య సూత్రములు 3000
3.⁠ ⁠వ్యాసశిక్ష సూత్రములు 3000
4.⁠ ⁠సప్తలక్షణి సూత్రములు  3000
5.⁠ ⁠ఆత్రేయ శిక్ష మరియు కౌండిన్య శిక్ష 3000


గమనిక: ఈ మౌఖిక పరీక్ష యజుర్వేదం మూలం పదం క్రమం అధ్యయనం చేస్తున్న విద్యార్థులు కూడా ఇవ్వవచ్చు.

పరీక్ష విధానం:
పరీక్ష ఇవ్వదలచిన విద్యార్థులు ప్రాతిశాఖ్య మూలసూత్రములు 4 భాగాలు దాటకుండా (6 అధ్యాయాలు) మరియు 4 భాగాలు (7 ప్రకరణాలు) దాటకుండా వ్యాస శీక్ష మూలం ఇవ్వవలెను.

వ్యాఖ్యాన పరీక్ష:
1. వ్యాఖ్యాన పరీక్ష మౌఖికమూ మరియు లేఖనము రెండు విధానాలుగా ఉంటుంది.
2. వ్యాఖ్యాన సహిత పరీక్షకు ఏదైనా సంస్థ లో క్రమాంతం, ఘనాంతం పట్టా పొంది ఉండవలెను.


వ్యాఖ్యాన పరీక్ష సత్కారాలు:
1. ప్రాతిశాఖ్య రెండు వ్యాఖ్యానాలతో - సత్కారం ₹5,000/-
2. వ్యాసశిక్ష వ్యాఖ్యానం సత్కారం - ₹5,000/-
3. సప్తలక్షణి సూత్రార్ధముతో - సత్కారం ₹5,000/-
4. ⁠ఆత్రేయ శిక్ష వ్యాఖ్యానం సత్కారం - 3,000/-
5. ⁠కౌండిన్య శిక్ష వ్యాఖ్యానం సత్కారం - 3,000/-
6. పూర్తిగా లక్షణ పరీక్ష ఇచ్చిన వారికి విశేష సత్కారం చేయబడుతుంది. అత్యుత్తమంగా పరీక్షించిన వారికి బిరుదు తో పాటు విశేష సత్కారం చేయబడుతుంది.


పరీక్ష సమయ సూచన:
పరీక్ష ఇవ్వదలచిన వారు రెండు, మూడు సార్లుగా, లేదా ఒకేసారి పరీక్ష ఇవ్వచ్చు.
సర్టిఫికెట్ కోర్సు పూర్తిగా పరీక్ష ఇచ్చిన తర్వాతే ఇవ్వబడుతుంది.`
    },
    sanskrit: {
      title: 'लक्षणम्',
      content: `वेदशास्त्र संवर्धिनी सभा
वार्षिक लक्षण परीक्षा प्रणालिका

पाठ्य विषयाः (ग्रन्थाः):
1. वर्णक्रमम्
2. प्रातिशाख्य सूत्राणि
3. व्यासशीक्षा सूत्राणि
4. सप्तलक्षणी सूत्राणि
5. आत्रेय शीक्षा
6. कौण्डिन्य शीक्षा

एतेषां मूलसूत्राणां तक्ष्णां पर्यन्तं मौखिकः परीक्षा भवति।

मौखिकी परीक्षा पुरस्काराः:
1. वर्णक्रमम् ५०००
2. प्रातिशाख्य सूत्राणि ३०००
3. व्यासशीक्षा सूत्राणि ३०००
4. सप्तलक्षणी सूत्राणि ३०००
5. आत्रेय शीक्षा च कौण्डिन्य शीक्षा ३०००

परीक्षा विधिः
प्रातिशाख्य मूलसूत्राणि चतुर्भागेषु न गत्वा (षड्भ्यां अध्यायेषु) तथा चतुर्भागेषु न गत्वा (सप्तषु प्रकरणेषु) व्यास शीक्षा मूलं दातव्यम्।

व्याख्यान परीक्षा विधिः:
1. व्याख्यान परीक्षा मौखिकी तथा लेखन विधिभ्यां भवति।
2. व्याख्यान सहिता परीक्षायै कस्माद्वा संस्थायां क्रमान्तम्, घनान्तम् पत्रं प्राप्तं भवनीयम्।
3. वयः सीमा: चत्वारिंश वर्षाः

व्याख्यान परीक्षा पुरस्काराः:
1. प्रातिशाख्य द्वाभ्यां व्याख्यानाभ्यां - पुरस्कारः ₹५,०००/-
2. व्यासशीक्षा व्याख्यानम् - पुरस्कारः ₹५,०००/-
3. सप्तलक्षणी सूत्रार्धेन - पुरस्कारः ₹५,०००/-
4. आत्रेय शीक्षा व्याख्यानम् - पुरस्कारः ₹३,०००/-
5. कौण्डिन्य शीक्षा व्याख्यानम् - पुरस्कारः ₹३,०००/-
6. परिपूर्णं लक्षण परीक्षा दत्वा तेषां विशेष पुरस्कारः क्रियते। अत्युत्तमरूपेण परीक्षिताः उपाधि सहितं विशेष पुरस्कारम् लभन्ते।

परीक्षा-समय-निर्देशः :
परीक्षां दातुम् इच्छन्तः परीक्षां द्विवारं, त्रिवारं, अथवा एकवारमेव अपि दातुं शक्नुवन्ति।
प्रमाणपत्र-पाठ्यक्रमः सम्पूर्णतया परीक्षां दत्त्वा एव प्रदानं क्रियते।`
    }
  },
  samskruta_sahitya: {
    telugu: {
      title: 'సంస్కృత సాహిత్య విశారద',
      content: `శ్రీ విద్యారణ్య వైదిక విద్యా విహారమ్ ట్రస్ట్
వేదశాస్త్ర సంవర్ధినీ సభా - భాగ్య నగరం

వార్షిక సంస్కృత "సాహిత్యవిశారద" పరీక్షలు

సంస్కృత సాహిత్య విశారద పాఠ్య ప్రణాళిక:

1. శబ్దమంజరి
   - సామాన్య శబ్దాలు
   - సర్వనామ శబ్దాలు
   - విశేష శబ్దాలు

2. మేము సూచించిన 20 ధాతువులు
   - భ్వాది 10 గణములలో 2 చొప్పున ధాతువులు

3. సమాసకుసుమావళి

4. అమరకోశం
   - ప్రథమ కాండ పూర్తి (తప్పనిసరి)
   - 2, 3 కాండలు (ఐచ్ఛికం)
   - సంపూర్ణ అమరకోశం పరీక్ష ఇచ్చిన వారికి ప్రత్యేక సత్కారం

5. కావ్య భాగం
   - రఘువంశము - 1 వ సర్గ
   - కుమార సంభవం - 1 వ సర్గ
   - శిశుపాలవధం - 1 వ సర్గ
   - కిరాత అర్జునీయం - 1 వ సర్గ
   - నైషధం - 1 వ సర్గ

6. నాటకం
   - అభిజ్ఞాన శాకుంతలం - చతుర్థ అంకమ్
   - దశకుమార చరితం - ప్రథమ ఉచ్ఛ్వాసం

7. ఇతర గ్రంథాలు
   - చంపూ రామాయణం - బాల కాండ
   - చంపూ భారతం - ప్రథమ స్తబకం
   - ఆపస్తంబ ధర్మ సూత్రం - మూలం సంపూర్ణం
   - ఆపస్తంబ గృహ్య సూత్రం - మూలం సంపూర్ణం
   - సిద్ధాంత కౌముది - పంచ సంధి ప్రకరణ పర్యంతం (వ్యాఖ్యా సహితం)

వ్యవస్థలు:
- సాహిత్యవిశారద పరీక్ష వైదిక మార్గంలో ఉంటున్న విద్యార్థులకు మాత్రమే లభ్యం
- 18 విభాగాలు 2 సంవత్సర రాల లోపు పరీక్ష పూర్తి చేయవలసి ఉంటుంది

పుരస్కారం:
- పరీక్ష పూర్తి చేసిన వారికి: ₹25,000/- మరియూ 2 గ్రాముల బంగారం + సాహిత్యవిశారద బిరుదు
- 3 సంవత్సరాల లోపు పూర్తి చేసిన వారికి: ₹10,000/- + సాహిత్యవిశారద బిరుదు`
    },
    sanskrit: {
      title: 'संस्कृत साहित्य विशारद',
      content: `श्री विद्यारण्य वैदिक विद्या विहारम् ट्रस्ट्
वेदशास्त्र संवर्धिनी सभा - भाग्यनगरम्

वार्षिक संस्कृत "साहित्यविशारद" परीक्षाः

संस्कृत साहित्य विशारद पाठ्य प्रणालिका:

1. शब्दमञ्जरी
   - सामान्य शब्दाः
   - सर्वनाम शब्दाः
   - विशेष शब्दाः

2. विहितानि २० धातवः
   - भ्वादि १० गणेषु २ प्रतिगणम्

3. समासकुसुमावली

4. अमरकोशः
   - प्रथम काण्डम् (आवश्यकम्)
   - द्वितीय, तृतीय काण्डे (विकल्पिकम्)
   - पूर्ण अमरकोश परीक्षायै विशेष पुरस्कारः

5. काव्य भागः
   - रघुवंशम् - १ सर्गः
   - कुमारसंभवम् - १ सर्गः
   - शिशुपालवधम् - १ सर्गः
   - किरातार्जुनीयम् - १ सर्गः
   - नैषधम् - १ सर्गः

6. नाटकम्
   - अभिज्ञानशाकुन्तलम् - चतुर्थ अङ्कम्
   - दशकुमारचरितम् - प्रथम उच्छ्वासम्

7. अन्य ग्रन्थाः
   - चम्पु रामायणम् - बाल काण्डम्
   - चम्पु भारतम् - प्रथम स्तबकम्
   - आपस्तम्ब धर्मसूत्रम् - मूलम् पूर्णम्
   - आपस्तम्ब गृह्यसूत्रम् - मूलम् पूर्णम्
   - सिद्धान्त कौमुदी - पञ्च सन्धि प्रकरण पर्यन्तम् (व्याख्या सहितम्)

विनियमाः:
- साहित्यविशारद परीक्षा वैदिकमार्गे स्थिताः छात्रेभ्यः एव प्रदानं
- १८ विभागाः २ वर्षयोः अन्तर्गतं परिपूर्णं क्रियन्तव्यम्

पुरस्कारः:
- परीक्षा समाप्ते: ₹२५,०००/- तथा २ ग्राम सुवर्णम् + साहित्यविशारद उपाधिः
- त्रिषु वर्षेषु समाप्ते: ₹१०,०००/- + साहित्यविशारद उपाधिः`
    }
  },
  vedaadhyai_samskruta: {
    telugu: {
      title: 'వేదాధ్యాయి సంస్కృత సాహిత్యశారద',
      content: `శ్రీ విద్యారణ్య వైదిక విద్యా విహారమ్ ట్రస్ట్
వేదశాస్త్ర సంవర్ధినీ సభా - భాగ్య నగరం

వార్షిక సంస్కృత సాహిత్య పరీక్షలు

వేదాధ్యాయి సంస్కృత "సాహిత్యశారద" పాఠ్య ప్రణాళిక:

1. అమరకోశం
   - 100 శ్లోకాలు - ₹1,000/-
   - 150 శ్లోకాలు - ₹1,000/-
   - 200 శ్లోకాలు - ₹1,000/-
   - 250 శ్లోకాలు - ₹1,000/-
   - 300 శ్లోకాలు - ₹1,000/-
   - 350 శ్లోకాలు - ₹1,000/-

2. శబ్దమంజరి, ధాతువులు (భ్వాది 10 గణములలో 2 చొప్పున) - ₹1,000/-

3. సమాసకుసుమావళి, రఘువంశము 1 వ సర్గ - ₹1,000/-

4. కుమారసంభవం 1 వ సర్గ - ₹1,000/-

5. కిరాతార్జునీయం 1 వ సర్గ - ₹1,000/-

6. శిశుపాలవధం 1 వ సర్గ - ₹1,000/-

7. నైషధం 1 వ సర్గ - ₹1,000/-

పరీక్ష విధానం:
- వేదాధ్యయన కాలంలో ఈ 12 విభాగాలు, ఇదే వరుస క్రమం కాకుండా మీ సౌకర్యం ప్రకారం ఎన్ని విభాగాలైనా ఒకేసారి పరీక్ష ఇవ్వచ్చు
- గరిష్టంగా 12 సంవత్సరాల లోపు ఈ 12 విభాగాలు పరీక్ష పూర్తి చేయవలసి ఉంటుంది

పుരస్కారం:
- 12 విభాగాలు పరీక్ష పూర్తి చేసిన వారికి: ₹10,000/- + 1 గ్రాము బంగారం + సాహిత్యశారద బిరుదు`
    },
    sanskrit: {
      title: 'वेदाध्यायी संस्कृत साहित्यशारद',
      content: `श्री विद्यारण्य वैदिक विद्या विहारम् ट्रस्ट्
वेदशास्त्र संवर्धिनी सभा - भाग्यनगरम्

वार्षिक संस्कृत साहित्य परीक्षाः

वेदाध्यायी संस्कृत "साहित्यशारद" पाठ्य प्रणालिका:

1. अमरकोशः
   - १०० श्लोकाः - ₹१,०००/-
   - १५० श्लोकाः - ₹१,०००/-
   - २०० श्लोकाः - ₹१,०००/-
   - २५० श्लोकाः - ₹१,०००/-
   - ३०० श्लोकाः - ₹१,०००/-
   - ३५० श्लोकाः - ₹१,०००/-

2. शब्दमञ्जरी, धातवः (भ्वादि १० गणेषु २ प्रतिगणम्) - ₹१,०००/-

3. समासकुसुमावली, रघुवंशम् १ सर्गः - ₹१,०००/-

4. कुमारसंभवम् १ सर्गः - ₹१,०००/-

5. किरातार्जुनीयम् १ सर्गः - ₹१,०००/-

6. शिशुपालवधम् १ सर्गः - ₹१,०००/-

7. नैषधम् १ सर्गः - ₹१,०००/-

परीक्षा विधिः:
- वेदाध्ययन काले एतेषां १२ विभागानाम् क्रमं न गृहीत्वा आपके सुविधानुसारं कति विभागानि अपि एकसाथ परीक्षा दातुं शक्यते
- अधिकतमं १२ वर्षेषु एतानि सर्वाणि विभागानि परीक्षायां समाप्यन्तां

पुरस्कारः:
- सर्वे १२ विभागाः समाप्ते: ₹१०,०००/- + १ ग्राम सुवर्णम् + साहित्यशारद उपाधिः`
    }
  }
};

export default function ParikshaSyllabus() {
  const { lang } = useLanguage();
  const [expanded, setExpanded] = useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  // Age limit information for each pariksha type
  const ageLimits = {
    krishna_yajurveda: { telugu: '35 సంవత్సరాల వరకు', sanskrit: '35 वर्षपर्यन्तम्' },
    lakshanam: { telugu: '40 సంవత్సరాల వరకు', sanskrit: '40 वर्षपर्यन्तम्' },
    samskruta_sahitya: { telugu: '30 సంవత్సరాల వరకు', sanskrit: '30 वर्षपर्यन्तम्' },
    vedaadhyai_samskruta: { telugu: '30 సంవత్సరాల వరకు', sanskrit: '30 वर्षपर्यन्तम्' }
  };

  const breadcrumbItems = [
    { label: lang === 'telugu' ? 'పరీక్ష' : 'परीक्षा', path: '/parikshaMgmt' },
    { label: lang === 'telugu' ? 'పాఠ్య క్రమాలు' : 'पाठ्य प्रणालिका' }
  ];

  const parikshaTypes = [
    'krishna_yajurveda',
    'lakshanam',
    'samskruta_sahitya',
    'vedaadhyai_samskruta'
  ];

  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      {/* Breadcrumb Navigation */}
      <Breadcrumb items={breadcrumbItems} />
      
      <Box sx={{ mb: 4 }}>
        <Typography
          variant="h4"
          sx={{
            fontWeight: 700,
            color: 'primary.main',
            mb: 1,
            textAlign: 'center'
          }}
        >
          {lang === 'telugu' ? 'పరీక్ష పాఠ్య క్రమాలు' : 'परीक्षा पाठ्य प्रणालिका'}
        </Typography>
        <Typography
          variant="body1"
          sx={{
            color: 'text.secondary',
            textAlign: 'center',
            mb: 3
          }}
        >
          
        </Typography>
      </Box>

      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        {parikshaTypes.map((type) => {
          const data = syllabusData[type];
          const content = data[lang];

          return (
            <Paper key={type} elevation={2} sx={{ overflow: 'hidden' }}>
              <Accordion
                expanded={expanded === type}
                onChange={handleChange(type)}
                sx={{
                  '&.MuiAccordion-root': {
                    boxShadow: 'none',
                    '&:before': {
                      display: 'none'
                    }
                  }
                }}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon sx={{ color: 'white' }} />}
                  sx={{
                    backgroundColor: '#7f4b2d',
                    color: 'white',
                    '& .MuiAccordionSummary-content': {
                      my: 2
                    },
                    '&:hover': {
                      backgroundColor: 'primary.dark'
                    }
                  }}
                >
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%', pr: 2 }}>
                    <Typography
                      variant="h6"
                      sx={{
                        fontWeight: 600,
                        fontSize: '1.1rem'
                      }}
                    >
                      {content.title}
                    </Typography>
                    {/* Age limit rule moved to the end of the syllabus details per design */}
                  </Box>
                </AccordionSummary>
                <AccordionDetails
                  sx={{
                    p: 3,
                    backgroundColor: '#f9f9f9',
                    borderTop: '2px solid #e0e0e0'
                  }}
                >
                  <Typography
                    component="div"
                    sx={{
                      whiteSpace: 'pre-wrap',
                      lineHeight: 1.8,
                      color: 'text.primary',
                      fontSize: '0.95rem',
                      fontFamily: lang === 'telugu' ? 'inherit' : 'inherit',
                      '& > *': {
                        mb: 1.5
                      }
                    }}
                  >
                    {content.content.split('\n\n').map((paragraph, idx) => (
                      <Box key={idx} sx={{ mb: 2 }}>
                        {paragraph}
                      </Box>
                    ))}
                  </Typography>

                  {/* Age limit rule rendered at the end of the syllabus (not in header) */}
                  <Box sx={{ mt: 2 }}>
                    <Box sx={{ borderLeft: '4px solid #FFD54F', backgroundColor: '#fff8e1', p: 2, borderRadius: 1 }}>
                      <Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 0.5 }}>
                        {lang === 'telugu' ? 'నియమం' : 'नियम'}
                      </Typography>
                      <Typography variant="body2">
                        {lang === 'telugu'
                          ? `వయ:పరిమితి : ${ageLimits[type].telugu}`
                          : `वयः सीमा : ${ageLimits[type].sanskrit}`}
                      </Typography>
                    </Box>
                  </Box>
                </AccordionDetails>
              </Accordion>
            </Paper>
          );
        })}
      </Box>
    </Container>
  );
}